import { render } from "./TulumSection.vue?vue&type=template&id=4e3ecf88&scoped=true"
import script from "./TulumSection.vue?vue&type=script&lang=js"
export * from "./TulumSection.vue?vue&type=script&lang=js"

import "./TulumSection.vue?vue&type=style&index=0&id=4e3ecf88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3ecf88"]])

export default __exports__